module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArElEQVQ4T92SOwoCAQxE31hYegEv4BHEQrDSUkHwHuI19iSinZWtCPZewtpWHImouD92YbtNlzAZMpMRDUsN92kTge0ZcAA6Fb4YmEo6Bu7nge0FsK9p6lLSLkUQje0EWFeQJJI2X0zqC7ajjyvmJSRbYCUpZLwr90bbXSD0jTMkJ2Ai6fE/L8yB7R5wAQYf8BUYSbpnLysNku0+cAaewFDSrUhWm5JYM0A52AtiICgRpPqSTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/drop_icon.png
// module id = +A3e
// module chunks = 0